import versailles from "./versailles";
import leChesnayRocquencourt from "./le-chesnay-rocquencourt";
import velizyVillacoublay from "./velizy-villacoublay";
import saintCyrLecole from "./saint-cyr-lecole";
import viroflay from "./viroflay";
import buc from "./buc";
import guyancourt from "./guyancourt";
import montignyLeBretonneux from "./montigny-le-bretonneux";
import trappes from "./trappes";
import chateaufort from "./chateaufort";
import boisDarcy from "./bois-darcy";
import fontenayLeFleury from "./fontenay-le-fleury";
import lesClayesSousBois from "./les-clayes-sous-bois";
import jouyEnJosas from "./jouy-en-josas";
import lesLogesEnJosas from "./les-loges-en-josas";
import toussusLeNoble from "./toussus-le-noble";
import plaisir from "./plaisir";
import villepreux from "./villepreux";
import chavenay from "./chavenay";
import rennemoulin from "./rennemoulin";
import noisyLeRoi from "./noisy-le-roi";
import bailly from "./bailly";
import saintNomLaBreteche from "./saint-nom-la-breteche";
import davron from "./davron";
import poissy from "./poissy";
import carrieresSousPoissy from "./carrieres-sous-poissy";
import orgeval from "./orgeval";
import chambourcy from "./chambourcy";
import villennesSurSeine from "./villennes-sur-seine";
import verneuilSurSeine from "./verneuil-sur-seine";
import vernouillet from "./vernouillet";
import morainvilliers from "./morainvilliers";
import maisonsLaffitte from "./maisons-laffitte";
import leMesnilLeRoi from "./le-mesnil-le-roi";
import acheres from "./acheres";
import conflansSainteHonorine from "./conflans-sainte-honorine";
import andresy from "./andresy";
import chanteloupLesVignes from "./chanteloup-les-vignes";
import maurecourt from "./maurecourt";
import trielSurSeine from "./triel-sur-seine";
import chatou from "./chatou";
import leVesinet from "./le-vesinet";
import croissySurSeine from "./croissy-sur-seine";
import bougival from "./bougival";
import laCelleSaintCloud from "./la-celle-saint-cloud";
import louveciennes from "./louveciennes";
import marlyLeRoi from "./marly-le-roi";
import lePortMarly from "./le-port-marly";
import houilles from "./houilles";
import carrieresSurSeine from "./carrieres-sur-seine";
import montesson from "./montesson";
import saintGermainEnLaye from "./saint-germain-en-laye";
import lePecq from "./le-pecq";
import mareilMarly from "./mareil-marly";
import letangLaVille from "./letang-la-ville";
import feucherolles from "./feucherolles";
import sartrouville from "./sartrouville";
import aigremont from "./aigremont";
import andelu from "./andelu";
import bazemont from "./bazemont";
import crespieres from "./crespieres";
import herbeville from "./herbeville";
import lesAlluetsLeRoi from "./les-alluets-le-roi";
import mareilSurMauldre from "./mareil-sur-mauldre";

const TEMPLATES = {
  versailles,
  "le-chesnay-rocquencourt": leChesnayRocquencourt,
  "velizy-villacoublay": velizyVillacoublay,
  "saint-cyr-lecole": saintCyrLecole,
  viroflay,
  buc,
  guyancourt,
  "montigny-le-bretonneux": montignyLeBretonneux,
  trappes,
  chateaufort,
  "bois-darcy": boisDarcy,
  "fontenay-le-fleury": fontenayLeFleury,
  "les-clayes-sous-bois": lesClayesSousBois,
  "jouy-en-josas": jouyEnJosas,
  "les-loges-en-josas": lesLogesEnJosas,
  "toussus-le-noble": toussusLeNoble,
  plaisir,
  villepreux,
  chavenay,
  rennemoulin,
  "noisy-le-roi": noisyLeRoi,
  bailly,
  "saint-nom-la-breteche": saintNomLaBreteche,
  davron,
  poissy,
  "carrieres-sous-poissy": carrieresSousPoissy,
  orgeval,
  chambourcy,
  "villennes-sur-seine": villennesSurSeine,
  "verneuil-sur-seine": verneuilSurSeine,
  vernouillet,
  morainvilliers,
  "maisons-laffitte": maisonsLaffitte,
  "le-mesnil-le-roi": leMesnilLeRoi,
  acheres,
  "conflans-sainte-honorine": conflansSainteHonorine,
  andresy,
  "chanteloup-les-vignes": chanteloupLesVignes,
  maurecourt,
  "triel-sur-seine": trielSurSeine,
  chatou,
  "le-vesinet": leVesinet,
  "croissy-sur-seine": croissySurSeine,
  bougival,
  "la-celle-saint-cloud": laCelleSaintCloud,
  louveciennes,
  "marly-le-roi": marlyLeRoi,
  "le-port-marly": lePortMarly,
  houilles,
  "carrieres-sur-seine": carrieresSurSeine,
  montesson,
  "saint-germain-en-laye": saintGermainEnLaye,
  "le-pecq": lePecq,
  "mareil-marly": mareilMarly,
  "letang-la-ville": letangLaVille,
  feucherolles,
  sartrouville,
  aigremont,
  andelu,
  bazemont,
  crespieres,
  herbeville,
  "les-alluets-le-roi": lesAlluetsLeRoi,
  "mareil-sur-mauldre": mareilSurMauldre,
};

export const getYvelinesCityTemplate = (templateId) =>
  TEMPLATES[templateId] || null;

export default TEMPLATES;
